export const defaultSiteConfiguration = {
    shouldRedirect: false,
    checksBeforeContinue: {
        productQuantity: true,
        customization: true,
        currentVariant: false,
        currentVariantQuantity: false
    },
    mustAskEcommerceProduct: false,
    showVariantComponent: false,
    isLayoutEnabled: false,
    areDetailsEnabled: true,
    isIframeMode: true,
    customization: {
        isTextureClipped: true,
        colorSpace: '', // '' | 'srgb' | 'srgb-linear'
        manageRaycast: true,
        acceleratedRaycast: true,
        mouseSensitivityOn3D: 2,
        handleSize2D: 15,
        handleSize3D: 30,
        handleSizeMobile2D: 25,
        handleSizeMobile3D: 50,
        initialModelRotation: 0,
        materials: {} as Record<string, any>,
        graphicElements: {
            isThemeLockedOnLoad: true
        },
        isEmissiveEnabled: false,
        isBaseDisplayed: true
    },
    exportFiles: {
        printFile: {
            extension: 'png',
            mustBeExported: true
        },
        proofFile: {
            extension: 'pdf',
            mustBeExported: true
        },
        screenshots: {
            mustBeExported: true
        },
        /**
         * Mockups : mise en scène de la création sur des photos du produit réel,
         * une image par vue, composée côté serveur.
         *
         * Vrai par défaut, mais SANS effet tant qu'un produit n'a pas été activé
         * au back-office (`Product.mockupEnabled`, faux par défaut) : rien ne
         * change pour les sites existants. Le passer à faux coupe la
         * fonctionnalité pour toute la boutique ; le storefront peut aussi se
         * prononcer par session (postMessage `mockupEnabled`, `?mockup=1|0`).
         */
        mockups: {
            mustBeExported: true
        }
    },
    urls: {
        shop: {
            customizerHomePage: ''
        },
        action: {
            logo: '',
            afterVisualValidation: ''
        }
    },
    display3DViewFirst: true,
    style: {
        proof: {
            backgroundColor: '#FFFFFF',
            fontFamily: 'Verdana',
            fontColor: '#40475B',
            headerColor: '#40475B',
            headerFontColor: '#FFFFFF',
            screenshotBackgroundColor: '#CCCCCC',
            strokeColor: '#40475B',
            isDisclaimerEnabled: false,
            disclaimerImagePath: ''
        }
    },
    mobile: {
        productListMode: 'carousel' as 'scrollBarList' | 'carousel'
    }
};
